export { PickupStoresStrategy } from './pickup-stores.strategy';
export { DeliveryStoresStrategy } from './delivery-stores.strategy';
